import {
  Token_ANY_getInstance2w9n8tbewmx1b as Token_ANY_getInstance,
  Token_BOOLEAN_getInstance1imjwvekoc8j as Token_BOOLEAN_getInstance,
  Token_STRING_getInstance1xe7h31onye8j as Token_STRING_getInstance,
  Token_NUMBER_getInstance3h0qmmxij905 as Token_NUMBER_getInstance,
  Token_LONG_getInstanceo364xilpufkq as Token_LONG_getInstance,
  Token_BEGIN_OBJECT_getInstancebag7ch821q11 as Token_BEGIN_OBJECT_getInstance,
  Token_BEGIN_ARRAY_getInstance1m9zfq25cdud1 as Token_BEGIN_ARRAY_getInstance,
  Token_NULL_getInstance1sp8yn17d7412 as Token_NULL_getInstance,
  Token_END_DOCUMENT_getInstanceq7szdjm8kumg as Token_END_DOCUMENT_getInstance,
  Token_END_OBJECT_getInstance3atpnap4azrkn as Token_END_OBJECT_getInstance,
  Token_END_ARRAY_getInstance3dpoufa7bg3im as Token_END_ARRAY_getInstance,
  Token_NAME_getInstance19jzx1o7f4ts5 as Token_NAME_getInstance,
} from './JsonReader.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { readAny17j2jqaxubdko as readAny } from './JsonReaders.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { JsonDataException2rdtm884tky1l as JsonDataException } from '../../exception/Exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toDoubleExact18clzpruqqw2d as toDoubleExact,
  toIntExact1n46an7ryabg9 as toIntExact,
  toIntExact1p16u7ro59o31 as toIntExact_0,
  toLongExact9cht6g9si07j as toLongExact,
} from './internal/Utils.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function anyToToken($this, any) {
  var tmp;
  if (any == null) {
    tmp = Token_NULL_getInstance();
  } else {
    if (!(any == null) ? isInterface(any, KtList()) : false) {
      tmp = Token_BEGIN_ARRAY_getInstance();
    } else {
      if (!(any == null) ? isInterface(any, KtMap()) : false) {
        tmp = Token_BEGIN_OBJECT_getInstance();
      } else {
        if (!(any == null) ? typeof any === 'number' : false) {
          tmp = Token_NUMBER_getInstance();
        } else {
          if (!(any == null) ? typeof any === 'bigint' : false) {
            tmp = Token_LONG_getInstance();
          } else {
            if (!(any == null) ? typeof any === 'number' : false) {
              tmp = Token_NUMBER_getInstance();
            } else {
              if (any instanceof JsonNumber()) {
                tmp = Token_NUMBER_getInstance();
              } else {
                if (!(any == null) ? typeof any === 'string' : false) {
                  tmp = Token_STRING_getInstance();
                } else {
                  if (!(any == null) ? typeof any === 'boolean' : false) {
                    tmp = Token_BOOLEAN_getInstance();
                  } else {
                    tmp = Token_ANY_getInstance();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function advanceIterator($this) {
  if ($this.t40_1 === 0) {
    $this.n40_1 = Token_END_DOCUMENT_getInstance();
    return Unit_instance;
  }
  var currentIterator = ensureNotNull($this.r40_1[$this.t40_1 - 1 | 0]);
  var tmp = $this.p40_1[$this.t40_1 - 1 | 0];
  if (!(tmp == null) ? typeof tmp === 'number' : false) {
    var tmp_0 = $this.p40_1;
    var tmp_1 = $this.t40_1 - 1 | 0;
    var tmp_2 = $this.p40_1[$this.t40_1 - 1 | 0];
    tmp_0[tmp_1] = ((!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE()) + 1 | 0;
  }
  if (currentIterator.v1()) {
    var next = currentIterator.w1();
    $this.o40_1 = next;
    var tmp_3 = $this;
    var tmp_4;
    if (!(next == null) ? isInterface(next, Entry()) : false) {
      tmp_4 = Token_NAME_getInstance();
    } else {
      tmp_4 = anyToToken($this, next);
    }
    tmp_3.n40_1 = tmp_4;
  } else {
    var tmp_5 = $this;
    var tmp_6;
    var tmp_7 = $this.p40_1[$this.t40_1 - 1 | 0];
    if (!(tmp_7 == null) ? typeof tmp_7 === 'number' : false) {
      tmp_6 = Token_END_ARRAY_getInstance();
    } else {
      tmp_6 = Token_END_OBJECT_getInstance();
    }
    tmp_5.n40_1 = tmp_6;
  }
}
function increaseStack($this) {
  if ($this.t40_1 === $this.p40_1.length) {
    $this.p40_1 = copyOf($this.p40_1, imul($this.p40_1.length, 2));
    $this.q40_1 = copyOf($this.q40_1, imul($this.q40_1.length, 2));
    $this.s40_1 = copyOf_0($this.s40_1, imul($this.s40_1.length, 2));
    $this.r40_1 = copyOf($this.r40_1, imul($this.r40_1.length, 2));
  }
  $this.t40_1 = $this.t40_1 + 1 | 0;
}
function findName($this, needle, haystack) {
  var expectedIndex = $this.s40_1[$this.t40_1 - 1 | 0];
  if (expectedIndex < haystack.v2() && haystack.w2(expectedIndex) === needle) {
    $this.s40_1[$this.t40_1 - 1 | 0] = $this.s40_1[$this.t40_1 - 1 | 0] + 1 | 0;
    return expectedIndex;
  } else {
    var index = haystack.w4(needle);
    if (!(index === -1)) {
      $this.s40_1[$this.t40_1 - 1 | 0] = index + 1 | 0;
    }
    return index;
  }
}
function getPathAsString($this) {
  return joinToString($this.s2s(), '.');
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      b41(_this__u8e3s4) {
        if (_this__u8e3s4 instanceof MapJsonReader())
          return _this__u8e3s4;
        var token = _this__u8e3s4.f40();
        // Inline function 'kotlin.check' call
        if (!token.equals(Token_BEGIN_OBJECT_getInstance())) {
          var message = 'Failed to buffer json reader, expected `BEGIN_OBJECT` but found `' + token.toString() + '` json token';
          throw IllegalStateException().o(toString(message));
        }
        var pathRoot = _this__u8e3s4.s2s();
        var tmp = readAny(_this__u8e3s4);
        var data = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
        return new (MapJsonReader())(data, pathRoot);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var MapJsonReaderClass;
function MapJsonReader() {
  if (MapJsonReaderClass === VOID) {
    class $ {
      constructor(root, pathRoot) {
        pathRoot = pathRoot === VOID ? emptyList() : pathRoot;
        this.l40_1 = root;
        this.m40_1 = pathRoot;
        this.o40_1 = null;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.p40_1 = Array(64);
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_0.q40_1 = Array(64);
        var tmp_1 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_1.r40_1 = Array(64);
        this.s40_1 = new Int32Array(64);
        this.t40_1 = 0;
        this.n40_1 = anyToToken(this, this.l40_1);
        this.o40_1 = this.l40_1;
      }
      h41() {
        // Inline function 'kotlin.apply' call
        if (!this.f40().equals(Token_BEGIN_ARRAY_getInstance())) {
          throw JsonDataException().k47('Expected BEGIN_ARRAY but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.o40_1;
        var currentValue = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : THROW_CCE();
        increaseStack(this);
        this.p40_1[this.t40_1 - 1 | 0] = -1;
        this.r40_1[this.t40_1 - 1 | 0] = currentValue.u1();
        advanceIterator(this);
        return this;
      }
      i41() {
        // Inline function 'kotlin.apply' call
        if (!this.f40().equals(Token_END_ARRAY_getInstance())) {
          throw JsonDataException().k47('Expected END_ARRAY but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        this.t40_1 = this.t40_1 - 1 | 0;
        this.r40_1[this.t40_1] = null;
        this.p40_1[this.t40_1] = null;
        advanceIterator(this);
        return this;
      }
      c41() {
        // Inline function 'kotlin.apply' call
        if (!this.f40().equals(Token_BEGIN_OBJECT_getInstance())) {
          throw JsonDataException().k47('Expected BEGIN_OBJECT but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        increaseStack(this);
        var tmp = this.q40_1;
        var tmp_0 = this.t40_1 - 1 | 0;
        var tmp_1 = this.o40_1;
        tmp[tmp_0] = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
        this.u4c();
        return this;
      }
      d41() {
        // Inline function 'kotlin.apply' call
        this.t40_1 = this.t40_1 - 1 | 0;
        this.r40_1[this.t40_1] = null;
        this.p40_1[this.t40_1] = null;
        this.q40_1[this.t40_1] = null;
        advanceIterator(this);
        return this;
      }
      v1() {
        switch (this.f40().b2_1) {
          case 3:
            return false;
          case 1:
            return false;
          default:
            return true;
        }
      }
      f40() {
        return this.n40_1;
      }
      e41() {
        if (!this.f40().equals(Token_NAME_getInstance())) {
          throw JsonDataException().k47('Expected NAME but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.o40_1;
        var data = (!(tmp == null) ? isInterface(tmp, Entry()) : false) ? tmp : THROW_CCE();
        this.p40_1[this.t40_1 - 1 | 0] = data.r3();
        this.o40_1 = data.s3();
        this.n40_1 = anyToToken(this, data.s3());
        return data.r3();
      }
      m41() {
        var value = this.o40_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value.toString();
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value.toString();
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value.toString();
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = value;
              } else {
                if (value == null) {
                  tmp = 'null';
                } else {
                  if (value instanceof JsonNumber()) {
                    tmp = value.v4a_1;
                  } else {
                    var message = 'Expected a String but got ' + toString_0(value) + ' instead';
                    throw IllegalStateException().o(toString(message));
                  }
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      ho() {
        if (!this.f40().equals(Token_BOOLEAN_getInstance())) {
          throw JsonDataException().k47('Expected BOOLEAN but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.o40_1;
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
        advanceIterator(this);
        return this_0;
      }
      y49() {
        if (!this.f40().equals(Token_NULL_getInstance())) {
          throw JsonDataException().k47('Expected NULL but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        advanceIterator(this);
        return null;
      }
      r41() {
        switch (this.f40().b2_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().k47('Expected a Double but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.o40_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toDoubleExact(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value;
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toDouble(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toDouble(value.v4a_1);
                } else {
                  var message = 'Expected a Double but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      sk() {
        switch (this.f40().b2_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().k47('Expected an Int but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.o40_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toIntExact_0(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toIntExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toInt(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toInt(value.v4a_1);
                } else {
                  var message = 'Expected an Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      eo() {
        switch (this.f40().b2_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().k47('Expected a Long but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.o40_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = fromInt(value);
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value;
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toLongExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toLong(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toLong(value.v4a_1);
                } else {
                  var message = 'Expected Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      s4c() {
        switch (this.f40().b2_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().k47('Expected a Number but was ' + this.f40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.o40_1;
        var tmp;
        var tmp_0;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp_1 = true;
          } else {
            tmp_1 = !(value == null) ? typeof value === 'number' : false;
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          tmp = new (JsonNumber())(toString(value));
        } else {
          if (!(value == null) ? typeof value === 'string' : false) {
            tmp = new (JsonNumber())(value);
          } else {
            if (value instanceof JsonNumber()) {
              tmp = value;
            } else {
              var message = 'Expected JsonNumber but got ' + toString_0(value) + ' instead';
              throw IllegalStateException().o(toString(message));
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      u40() {
        var tmp0_elvis_lhs = this.o40_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw JsonDataException().k47('Expected a non-null value at path ' + getPathAsString(this));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var data = tmp;
        // Inline function 'kotlin.also' call
        advanceIterator(this);
        return data;
      }
      e40() {
        advanceIterator(this);
      }
      q6() {
      }
      t4c(names) {
        while (this.v1()) {
          var name = this.e41();
          var index = findName(this, name, names);
          if (!(index === -1)) {
            return index;
          }
          this.e40();
        }
        return -1;
      }
      u4c() {
        var container = this.q40_1[this.t40_1 - 1 | 0];
        this.p40_1[this.t40_1 - 1 | 0] = null;
        var tmp = this.r40_1;
        var tmp_0 = this.t40_1 - 1 | 0;
        // Inline function 'kotlin.collections.iterator' call
        tmp[tmp_0] = ensureNotNull(container).q3().u1();
        this.s40_1[this.t40_1 - 1 | 0] = 0;
        advanceIterator(this);
      }
      s2s() {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().u2();
        result.z2(this.m40_1);
        var inductionVariable = 0;
        var last = this.t40_1;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_safe_receiver = this.p40_1[index];
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              result.n2(tmp0_safe_receiver);
            }
          }
           while (inductionVariable < last);
        return result;
      }
    }
    initMetadataForClass($, 'MapJsonReader');
    MapJsonReaderClass = $;
  }
  return MapJsonReaderClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  MapJsonReader as MapJsonReader2b7ri7r44421y,
  Companion_instance as Companion_instance3bl0oo0sjhkhb,
};
//endregion

//# sourceMappingURL=MapJsonReader.mjs.map
